module.exports = __webpack_public_path__ + "img/CRT_Spear-004.d4d30400.png";